import { KeyValuePair } from '../../../../models/key-value-pair';

export class FileShareWorkerRangeModel {
  label: string;
  beginIp: string;
  endIp: string;
  annotations: KeyValuePair[];
}
